var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3979_25579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 20.9489C11.3849 20.94 11.7543 20.7953 12.0429 20.5403C12.3314 20.2853 12.5205 19.9365 12.5766 19.5555H9.36218C9.41992 19.9468 9.61782 20.3039 9.91909 20.5602C10.2204 20.8165 10.6045 20.9546 11 20.9489Z",
    fill: "var(--klothed-bgColor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.075 17.1905L19.8672 17.0072C19.2778 16.482 18.7618 15.8797 18.3333 15.2167C17.8654 14.3016 17.5849 13.3022 17.5083 12.2772V9.25833C17.5059 8.89163 17.4732 8.52576 17.4106 8.16444C16.3754 7.95167 15.4456 7.38773 14.7785 6.56808C14.1114 5.74844 13.7481 4.72345 13.75 3.66666V3.28166C13.112 2.96767 12.4264 2.76118 11.7211 2.67055V1.90055C11.7211 1.68418 11.6352 1.47667 11.4822 1.32367C11.3292 1.17067 11.1217 1.08472 10.9053 1.08472C10.6889 1.08472 10.4814 1.17067 10.3284 1.32367C10.1754 1.47667 10.0894 1.68418 10.0894 1.90055V2.70111C8.51016 2.92389 7.0648 3.7105 6.02019 4.91573C4.97559 6.12096 4.40228 7.66341 4.40611 9.25833V12.2772C4.32958 13.3022 4.04909 14.3016 3.58111 15.2167C3.15999 15.8781 2.65234 16.4803 2.07167 17.0072L1.86389 17.1905V18.9139H20.075V17.1905Z",
    fill: "var(--klothed-bgColor)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3334 6.7222C20.0209 6.7222 21.3889 5.35418 21.3889 3.66664C21.3889 1.9791 20.0209 0.611084 18.3334 0.611084C16.6459 0.611084 15.2778 1.9791 15.2778 3.66664C15.2778 5.35418 16.6459 6.7222 18.3334 6.7222Z",
    fill: "var(--klothed-bgColor)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3979_25579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "var(--klothed-textColor)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationSelected);
export default __webpack_public_path__ + "static/media/notificationSelected.4325d1e2cba8e64c9bc759623a7533cd.svg";
export { ForwardRef as ReactComponent };